import React from "react";
import { Link } from "react-router-dom";

export default function Footer_menu(props) {
  return (
    <div className="footer-menu-wrapper">
      <h6 className="footer-title">{props.title}</h6>

      <ul className="footer-menu-list">
        <li><Link to="/view_for_rent">{props.text1}</Link></li>
        <li><Link to="/view_for_job">{props.text2}</Link></li>
        <li><Link to="/view_for_events">{props.text3}</Link></li>
        <li><Link to="/view/BuyAndSell">{props.text4}</Link></li>
        <li><Link to="/view_for_Babysitter_and_nannies">{props.text5}</Link></li>
        <li><Link to="/view_for_localBiz_and_Services">{props.text6}</Link></li>
      </ul>
    </div>
  );
}